/**
 * Nav search
 */
export const navSearch = () => {
	const theButton = document.querySelector('#search-icon');
	const theTrigger = document.querySelectorAll('.search-bar');

	theButton.onclick = function () {
		for (const x of theTrigger) {
			x.classList.toggle('search-active');
		}
	};

	document
        .getElementById('search-icon')
        .addEventListener('click', function () {
            document.getElementById('search-icon').classList.toggle('close-icon');
        });
};
